import i18n from '../../../i18n';

export const CREDIT_CARD = 'credit-card';
export const BANK_TRANSFER = 'bank-transfer';
export const CHECK_BOOK = 'check-book';

const names = {
    [CREDIT_CARD]: 'followup.credit_card',
    [BANK_TRANSFER]: 'followup.bank_transfert',
    [CHECK_BOOK]: 'followup.check_book'
};

const by = {
    [CREDIT_CARD]: 'followup.by',
    [BANK_TRANSFER]: 'followup.by',
    [CHECK_BOOK]: 'followup.by',
};

export const selectOptions = [
    {
        value: CREDIT_CARD,
        label: methodName(CREDIT_CARD)
    },
    {
        value: BANK_TRANSFER,
        label: methodName(BANK_TRANSFER)
    },
    {
        value: CHECK_BOOK,
        label: methodName(CHECK_BOOK)
    }
];

export function methodName(type) {
    return i18n.t(names[type]);
}

export function byMethodName(type) {
    return i18n.t(by[type]) + ' ' + methodName(type);
}
